import section from "fragments/section"
import gql from "graphql-tag"

const GET_SECTIONS = gql`
  ${section}

  query sections($createdAt: String) {
    sections(createdAt: $createdAt) {
      ...Section
    }
  }
`
export default GET_SECTIONS
